// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"3ecf8ee2","621":"c5ebeeff","743":"30649254"}[chunkId] + ".chunk.js";
};